let cleanupBanner = () => {};

document.addEventListener('turbo:load', () => {
  cleanupBanner();
  const banner = document.querySelector('[data-laser-banner]');
  if (!banner) return;

  const video = banner.querySelector('video');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 576px)');
  const connection = navigator.connection;
  let ready = false;
  let idleId;
  let timerId;
  let visible = false;
  let failed = false;
  const autoplayAllowed = () => ready && desktop.matches && !motion.matches &&
    !(connection && (connection.saveData || ['slow-2g', '2g', '3g'].includes(connection.effectiveType)));
  const play = () => {
    if (failed) return;
    if (!video.getAttribute('src')) {
      video.src = video.canPlayType('video/webm; codecs="vp9"') ? video.dataset.webm : video.dataset.src;
    }
    video.muted = true;
    video.play().catch(() => { /* Keep the poster if autoplay is blocked. */ });
  };
  const sync = () => {
    if (visible && !document.hidden && autoplayAllowed()) play();
    else video.pause();
  };
  video.addEventListener('error', () => {
    failed = true;
    video.hidden = true;
  });
  const onMotionChange = sync;
  motion.addEventListener('change', onMotionChange);
  desktop.addEventListener('change', sync);
  if (connection) connection.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  const onReady = () => { ready = true; sync(); };
  const afterLoad = () => {
    if (window.requestIdleCallback) idleId = window.requestIdleCallback(onReady, { timeout: 2000 });
    else timerId = window.setTimeout(onReady, 200);
  };
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    sync();
  }, { threshold: 0.1 });
  observer.observe(banner);
  cleanupBanner = () => {
    observer.disconnect();
    video.pause();
    window.removeEventListener('load', afterLoad);
    if (idleId !== undefined) window.cancelIdleCallback(idleId);
    window.clearTimeout(timerId);
    motion.removeEventListener('change', onMotionChange);
    desktop.removeEventListener('change', sync);
    if (connection) connection.removeEventListener('change', sync);
    document.removeEventListener('visibilitychange', sync);
    cleanupBanner = () => {};
  };
});

document.addEventListener('turbo:before-cache', () => cleanupBanner());
